import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'
import { pxToRem } from '#commerce/utils/pxToRem'

export default {
  brandClasses: {
    container: 'space-y-2 <md:bg-transparent md:(p-6 -mx-6) lg:space-y-4',
    containerWidth: 'md:max-w-3/5 lg:max-w-2/5',
    containerWrapper: 'px-4 md:px-12'
  },
  brandStyles: {
    containerFullHeight: (height) => ({
      h: {
        sm: `calc(100svh - ${pxToRem(height)})`
      }
    })
  }
} satisfies RecursivePartial<CMSConfig['imageBanner']>
